import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output, inject, Input, signal } from '@angular/core';
import { AssetsUrlPipe } from '../../../pipes/assets-url.pipe';
import { UpaAsyncService } from '../../../services/upa-async.service';
import { redirectToUrl } from '../utils/navigation.utils';
import { DECOLAR_APP_INSTALL_URL, SHARE_WITH_FRIENDS_URL } from '../utils/urls.constants';

@Component({
  selector: 'al-welcome-enroll',
  standalone: true,
  imports: [CommonModule, AssetsUrlPipe],
  templateUrl: './welcome-enroll.component.html',
  styleUrls: ['./welcome-enroll.component.scss']
})
export class WelcomeEnrollComponent implements OnInit {
  @Input() source = '';
  @Input() isClube = false;
  @Input() isWebView = false;
  @Input() enrolledEmail: string | null = null;
  @Output() shareBenefitCopied = new EventEmitter<void>();

  private upaAsyncService = inject(UpaAsyncService);
  isOpen = signal(true);

  private readonly WELCOME_MODAL_SOURCES = [
    'enrollment-backend-fdepois',
    'enrollment-backend',
    'enrollment-frontend',
  ];

  get showWelcomeModal(): boolean {
    return this.WELCOME_MODAL_SOURCES.includes(this.source.toLowerCase()) && this.isOpen();
  }

  ngOnInit(): void {
    this.trackModalShowIfNeeded();
  }

  private getModalShowTrackName(): string {
    if (this.isClube && this.isWebView) {
      return 'show-modal-clube-compartir';
    }
    if (!this.isClube && this.isWebView) {
      return 'show-modal-noclube-compartir';
    }
    if (this.isClube && !this.isWebView) {
      return 'show-modal-clube-install';
    }
    return 'show-modal-noclube-install';
  }

  private trackModalShowIfNeeded(): void {
    if (!this.showWelcomeModal) {
      return;
    }
    this.upaAsyncService
      .trackToGeneric(
        'system-action',
        this.getModalShowTrackName(),
        'show',
        'ifood-landing',
        { source: this.source }
      )
      .subscribe();
  }

  closeModal(): void {
    this.isOpen.set(false);
  }

  shareBenefit(): void {
    if (typeof navigator !== 'undefined' && navigator.clipboard) {
      navigator.clipboard.writeText(SHARE_WITH_FRIENDS_URL);
    }
    this.upaAsyncService
      .trackToGeneric(
        'user-action',
        'welcome_enroll_compartilhe_com_amigos',
        'click',
        'ifood-landing',
        { source: this.source }
      )
      .subscribe();
    this.closeModal();
    this.shareBenefitCopied.emit();
  }

  downloadApp(): void {
    this.upaAsyncService
      .trackToGeneric(
        'user-action',
        'welcome_enroll_baixar_app',
        'click',
        'ifood-landing',
        { source: this.source }
      )
      .subscribe();
    redirectToUrl(DECOLAR_APP_INSTALL_URL);
  }

  onMainActionClick(): void {
    if (this.isWebView) {
      this.shareBenefit();
      return;
    }
    this.downloadApp();
  }
}